import { useState } from 'react';
import { IResponseDataBody } from 'services/response';
import shopApis from 'services/shop/apis';
import { ICategoryItemData } from 'services/shop/types/categories';
import { bookingV2LoadingRef } from './Loading';
type IInquiryCustomerHandler = {
  onStart?: () => void;
  onDone?: (data: ICategoryItemData[]) => void;
};
const useQueryServicesByStaff = (handler?: IInquiryCustomerHandler): [({
  data: ICategoryItemData[];
}), (staffId?: string) => Promise<void>] => {
  const [timeSlots, setTimeSlots] = useState<ICategoryItemData[]>([]);
  const _debounce = async (staffId?: string) => {
    bookingV2LoadingRef.current?.open();
    handler?.onStart?.();
    try {
      const res: IResponseDataBody<ICategoryItemData[]> = await shopApis.getCategoriesByStaff(staffId || '');
      const resData = res?.data?.data;
      if (resData) {
        const timeSlots = res.data.data;
        handler?.onDone?.(timeSlots);
        setTimeSlots(timeSlots);
      } else {
        handler?.onDone?.([]);
      }
    } catch (error) {
      handler?.onDone?.([]);
    } finally {
      bookingV2LoadingRef.current?.close();
    }
  };

  return [{ data: timeSlots }, _debounce];
};

export default useQueryServicesByStaff;
